<template>
	<div class="form form-study" :class="'cols-' + cols">

		<div class="row">
			<div class="col half">
				<div class="line">
					<input type="checkbox" id="with-maquette" v-model="includeWith" class="checkbox-maquette" >
					<label for="with-maquette">Avec maquette </label>
					<input type="checkbox" id="without-maquette" v-model="includeWithout" class="checkbox-maquette">
					<label for="without-maquette">Sans maquette</label>
				</div>
				<div class="line">
					<label class="label">Segment de marché</label>
					<select class="input mandatory" v-model="form.segment" :disabled="readonly">
						<option v-for="segment in available_segments" :key="segment.id" :value="segment">
							{{ segment.code }} - {{ segment.nom }}
							</option>
					</select>
				</div>

				<div class="line">
					<div class="row">
						<div class="col half">
							<label class="label">Type d'étude</label>
							<select class="input mandatory" v-model="form.type" :disabled="readonly">
								<option v-for="type in  available_etude_types"
								:key="type.id"
								:value="type"
								>
									{{ type.nom }}
								</option>
							</select>
						</div>
						<div v-if="form.segment.code !== 'GIE'" class="col half">
							<label class="label">Promoteur</label>
							<input type="text" class="input" v-model="form.promoteur" :disabled="readonly">
						</div>
					</div>
				</div>

				<div class="line">
					<div class="row">
						<div class="col half field">
							<label class="label">Code Evalis</label>
							<input type="text" class="input" v-model="form.evalis_code" :disabled="readonly || code_evalis.status =='pending' " @blur="check_evalis_code()">
							<icon :class="code_evalis.status" :file="code_evalis.icon" :size="16" />
							<!-- <icon class="failed" file="x-circle" :size="16" /> -->
							<!-- <icon class="pending" file="loader" :size="16" />
							<icon class="success" file="check-circle" :size="16" /> -->
						</div>
						<div v-if="form.segment.code === 'SCPI' && !new_study_for_active_project && !readonly" class="col half field">
							<label class="label">Code Immeuble Kyaneos</label>
							<input-autocomplete
								class="input"
								placeholder="Code Immeuble Kyaneos"
								itemtext="Code"
								:value="form.kyaneos"
								@input="form.kyaneos = $event.item"
								:items="kyaneosOptions"
								:readonly="kyaneosOptionsLoading"
								style="z-index: 111112; position: relative;"
								:showonfocus="true"
							/>
							<icon v-if="kyaneosOptionsLoading" class="pending" file="loader" :size="16" />
						</div>
						<!-- <div class="col half">
							<label class="label">Code Zoho CRM</label>
							<input type="text" class="input" v-model="form.zoho_code">
						</div> -->
					</div>
				</div>
				<div class="line mandatory">
					<div class="map" id="new-study-map"></div>

					<div class="address-search">
						<input
							type="text"
							class="input"
							:class="{ 'disabled': new_study_for_active_project }"
							v-model="form.address"
							@change="get_geo_data()" @keyup.enter="get_geo_data()"
							placeholder="Entrer une adresse à rechercher..."
							:disabled="new_study_for_active_project || readonly || form.segment.code === 'SCPI'"
						/>
						<button @click="get_geo_data()"><icon file="search" :size="20" /></button>
					</div>
					<div class="address-full">
						<span v-if="this.form.geo.address_full && this.form.geo.departement">
							{{ this.form.geo.address_full }}<br>
							{{ this.form.geo.departement.nom }}, {{ this.form.geo.region.nom }}<br>
							[ {{ this.form.geo.lat }}, {{ this.form.geo.lon }} ]
						</span>
						<span v-else>
							Adresse introuvable
						</span>
						<div v-show="address_loading" class="address-loading">
							<icon file="loader" />
						</div>
					</div>
				</div>

			</div>
			<div class="col half">

				<div class="line">
					<label class="label">Collaborateurs ADEQUATION</label>

					<input-autocomplete
						class="input"
						placeholder="Ajouter un collaborateur..."
						@input="add_user($event, 'internal')"
						:items="users_internal"
						readonly = "true"
					/>

					<div class="users">
						<div v-if="!(Array.isArray(form.users.internal) && form.users.internal.length)" class="no-user">Aucun collaborateur pour le moment</div>
						<row-user
							v-for="user in form.users.internal"
							:user="user"
							:key="user.id"
							:show_user_tooltip="cols == 2"
							@remove="remove_user(user, 'internal')"
							readonly="true"
						/>
					</div>

				</div>
			</div>
		</div>

		<div class="buttons">
			<button class="button" :class="{ 'validated': validated_form && !readonly, 'invalidated': !validated_form || readonly }" @click="submit()" :disabled="!validated_form || loading || readonly">
				<span v-show="!loading">Enregistrer</span>
				<icon class="loading" file="loader" v-show="loading" :size="24" />
			</button>
		</div>

	</div>
</template>

<script>
import { mapGetters } from "vuex";
import L from "leaflet";
import axios from "axios";
import study_utils from "@/libs/study_utils";
import InputAutocomplete from "@/components/global/input-autocomplete";
import RowUser from "@/components/study/sidebar/row-user";
import moment from "moment";
import _ from "lodash";
moment.locale("fr");

export default {
	name: "form-study",
	data: function () {
		return {
			init_form: null,
			includeWith: true,
			includeWithout: true,
			address_loading: false,
			map_osm: false,
			map_markers: false,
			kyaneosOptionsLoading: false,
			kyaneosOptions: [],
			form: {
				segment: {
					code: null
				},
				study_status: this.default_status,
				type: "",
				evalis_code: "",
				zoho_code: "",
				address: "",
				insee_code: "",
				user_internal: "",
				kyaneos: {},
				geo: {
					address_full: "",
					score: 0,
					insee_code: "",
					postal_code: "",
					city: "",
					type: "",
					departement: {},
					region: {},
					lat: "",
					lon: "",
				},
				users: {
					internal: []
				}
			},
			loading: false,
			check_evalis_pending: false,
			evalis_code_valid: false,
		};
	},
	props: {
		"cols": { default: 2 },
		"mode": { default: "creation" }, // can be 'creation' or 'edition'
		"readonly": { default: false },
	},
	computed: {
		...mapGetters([ "app", "study", "new_study_for_active_project", "active_project", "active_study", "user_details"]),
		validated_form () {
			// console.log("validating form", this.form);
			if (_.isEmpty(this.form.segment)) {
				// console.log('segment is empty');
				return false;
			}
			if (_.isEmpty(this.form.type)) {
				// console.log('type is empty');
				return false;
			}
			if (_.isUndefined(this.form.geo.lat) || this.form.geo.lat.length == 0) {
				// console.log('lat/lon empty');
				return false;
			}
			return true;
		},
		available_segments () {
			const available_segments = [];
			for (const template of this.study.lists.templates){
				const respectCheckboxes = ((template.templated && this.includeWith) || (!template.templated && this.includeWithout));
				if (respectCheckboxes && !available_segments.map((sgm) => sgm.id).includes(template.segment.id)){
					available_segments.push(template.segment);
				}
			}
			return available_segments;
		},
		available_etude_types () {
			const currentSegment = this.form.segment;
			const available_etude_types = [];

			if (currentSegment != null){
				for (const template of this.study.lists.templates){
					const respectCheckboxes = ((template.templated && this.includeWith) || (!template.templated && this.includeWithout));
					if (template.segment.id === currentSegment.id && respectCheckboxes && !available_etude_types.map((ett) => ett.id).includes(template.etudeType.id)){
						available_etude_types.push(template.etudeType);
					}
				}
			}
			//set default etude_type (only if no etudetype already set)
			if ((!this.active_study || !this.active_study.etudeType) && (available_etude_types != null && available_etude_types.length > 0)){
				this.form.type = available_etude_types[0];
			}

			return available_etude_types;
		},
		default_status: function () {
			const status = _.find(this.study.lists.statuts, ["slug", "en-cours"]);
			return status;
		},
		users_internal: function () {
			const that = this;
			const users = _.filter(this.study.lists.users, function (user) {
				return user.AD && _.findIndex(that.form.users.internal, { id: user.id }) == -1;
			});
			return _.map(users, function (user) {
				const item = {};
				item.value = user;
				item.label = user.prenom + " " + user.nom;
				return item;
			});
		},
		code_evalis: function (){
			let code_evalis = {
				status: "failed",
				icon: "x-circle"
			};
			if (this.check_evalis_pending){
				code_evalis = {
					status: "pending",
					icon: "loader"
				};
			} else if (this.evalis_code_valid || this.active_study.evalisReference){
				code_evalis = {
					status: "success",
					icon: "check-circle"
				};
			}
			return code_evalis;
		}
	},
	watch: {
		"form.segment.code": {
			immediate: true,
			async handler (value) {
				if (value === "SCPI") {
					this.kyaneosOptionsLoading = true;
					const data = await study_utils.get_kyaneos_all_immeubles_data();
					const codes = [...new Set(data.map(immeuble => ({label: immeuble.Code, value: immeuble})))];
					this.kyaneosOptions = codes;
					this.kyaneosOptionsLoading = false;
				}
			}
		},
		"form.kyaneos" (value) {
			if (!this.form.kyaneos || value == undefined || value.length == 0){
				return;
			}
			this.form.address = `${value.Adresse1}, ${value.CodePostal} ${value.Ville}`;
			this.form.kyaneos = value;
			this.get_geo_data();
		}
	},
	methods: {
		init_geo_contributors () {
			// 2 - get location from active_project
			this.form.address = this.active_project.adresse.adresse;
			this.form.lat = this.active_project.position.location.lat;
			this.form.lon = this.active_project.position.location.lon;
			this.form.kyaneos = this.active_project.kyaneos;
			this.get_geo_data();

			// 3 - get contributors from actie_project
		    this.form.users.internal = _.clone(this.active_project.contributeurs);
		},
		init_projet_and_study_data () {
			// get data from existing active_study and project
			// 1 - study data
			this.form.segment = this.active_study.segment;
			this.form.study_status = this.active_study.statut;
			this.form.type = this.active_study.etudeType;
			this.form.evalis_code = this.active_study.evalisReference;
			this.form.zoho_code = this.active_study.zohoReference;
			// 2 - project data
			this.form.promoteur = this.active_project.promoteur;

			this.init_geo_contributors();
		},
		addCurrentUserToContributors () {
			// add if not already in list
			if (_.find(this.form.users.internal, ["id", this.user_details.id]) == null) {
				this.add_user( { item: this.user_details }, "internal" );
			}
		},
		add_user: function (e, type) {
			this.form.users[type].push(e.item);
		},
		remove_user: function (e, type) {
			const index = _.findIndex(this.form.users[type], e.item);
			if (index > -1) this.form.users[type].splice(index, 1);
		},
		submit: async function () {

			const should_check = ["address", "segment", "type"];
			let refresh_stat_data = false;
			let i = 0;
			while (!refresh_stat_data && i < should_check.length){
				// check every key. If one has changed, the qlik data must be refreshed
				const key = should_check[i];
				refresh_stat_data = JSON.stringify(this.init_form[key]) != JSON.stringify(this.form[key]);
				i += 1;
			}

			this.loading = true;
			const self = this;
			const project_values = {
				code: `P_${this.form.geo.lat}_${this.form.geo.lon}`,
				nom: this.form.geo.address_full,
				dateCommande: moment().format(),
				promoteur: this.form.promoteur,
				statut: this.default_status,
				segment: this.form.segment,
				position: {
					location: {
						lat: this.form.geo.lat,
						lon: this.form.geo.lon,
					},
					type: this.form.geo.type,
					confiance: this.form.geo.score
				},
				adresse: {
					adresse: this.form.geo.address_full,
					codeInsee: this.form.geo.insee_code,
					codePostal: this.form.geo.postal_code,
					ville: this.form.geo.city
				},
				customGeoDetails: {
					kyaneos: this.form.kyaneos,
				},
				contributeurs: this.form.users.internal
			};
			if (this.new_study_for_active_project || this.mode == "edition") {
				project_values.id = this.active_project.id;
			}

			const study_values = {
				nom: this.form.geo.address_full,
				dateCreation: moment().format(),
				pdfLien: "",
				evalisReference: this.form.evalis_code,
				zohoReference: this.form.zoho_code,
				etudeData: {
				},
				qlikData: {
				},
				etudeType: this.form.type,
				projet: {
					id: null, // to be provided by web service POST /Cdc/Projet (creation)
				},
				statut: this.default_status,
				segment: this.form.segment,
			};
			// console.log(study_values);
			if (this.mode !== "creation"){
				study_values.etudeData.titre = "";
				study_values.etudeData.sous_titre = "";
			} else {
				// console.log("CREATION");
				// console.log("this.study.code_evalis_status : ",this.study.code_evalis_status);
				//set code_evalis_status & code_evalis_icon
				study_values.etudeData.code_evalis_status = this.study.code_evalis_status;
				study_values.etudeData.code_evalis_icon = this.study.code_evalis_icon;
			}
			const project_study_data = {
				existing_project: this.new_study_for_active_project,
				project_values: project_values,
				study_values: study_values,
			};
			// console.log('project_study_data before creation/update', project_study_data);

			if (this.mode == "creation") {
				project_study_data["callback"] = function (data) {
					// console.log('calling study creation callback with data', data);
					self.$store.dispatch("set_new_study_for_active_project", { value: false });
					self.$router.push({ name: "study", params: data });
				};
				await this.$store.dispatch("create_study", project_study_data );
			} else {
				await this.$store.dispatch("update_study_and_project", {data: project_study_data, refresh_stat_data: refresh_stat_data} );
			}
			this.init_form = _.cloneDeep(this.form);
			this.loading = false;
		},
		init_map: function () {
			const coords = [45.767609, 4.835069];
			const GrayLight = L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
				attribution: "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
			});

			this.map_osm = L.map("new-study-map", {
				center: coords,
				zoom: 14,
				minZoom: 5,
				zoomControl: false,
				layers: [ GrayLight ]
			});
			
			// this.map_osm.zoomControl.setPosition('topright')
		},
		reload_map: function (lat, lon) {
			if (this.map_markers) this.map_osm.removeLayer(this.map_markers);

			if (lat && lon) {
				const that = this;
				const center = L.latLng(lat, lon);
				this.map_osm.panTo(center, { animate: true });

				this.map_markers = L.layerGroup().addTo(this.map_osm);


				const svgToDataURL = require("svg-to-dataurl");
				const dataUrl = svgToDataURL(require("@/assets/ressources/icons/map_icons/" + "projet" + ".svg"));
				const marker = L.marker(center, { draggable: !this.new_study_for_active_project, autoPan: true, icon: L.icon({ iconUrl: dataUrl, iconSize: [40, 40] }) }).addTo(this.map_markers);
				marker.on("dragend", function () {
					const latlng = marker.getLatLng();
					that.address_loading = true;
					that.form.address = "";
					axios.get(`${process.env.VUE_APP_API_BASE_URL}api/etalab/reverse/?lon=` + latlng.lng + "&lat=" + latlng.lat)
						.then(function (response) {
							if (response.data.content.features && response.data.content.features[0]) {
								that.set_geo_data(response, lon, lat);
							}
							if (that.form.geo.insee_code && that.form.geo.insee_code.length == 5) {
								axios.get("https://geo.api.gouv.fr/communes/" + that.form.geo.insee_code + "?fields=departement,region,codesPostaux")
								// axios.get(`${process.env.VUE_APP_API_BASE_URL}Etalab/Api/Communes/` + that.form.geo.insee_code + "?fields=departement,region,codesPostaux")
									.then(function (response) {
										if (response.data.departement) that.form.geo.departement = response.data.departement;
										if (response.data.region) that.form.geo.region = response.data.region;

									})
									.catch(function () {
										console.error("error while retriving region data");
										that.set_geo_data({});
									});
							}
						})
						.catch(function () {
							that.set_geo_data({});
						})
						.finally(function () {
							that.address_loading = false;
						});
				});
			}
		},
		set_geo_data: function (response,qlng,qlat) {
			if ( response && response.data && response.data.content && response.data.content.features[0] ) {
				const hit = response.data.content.features[0];
				if (hit) {
					if (hit.geometry) {
						this.form.geo.lon = qlng != null ? qlng : hit.geometry.coordinates[0];
						this.form.geo.lat = qlat != null ? qlat : hit.geometry.coordinates[1];
					}
					if (hit.properties) {
						this.form.geo.score = hit.properties.score;
						this.form.geo.postal_code = hit.properties.postcode;
						this.form.geo.insee_code = hit.properties.citycode;
						this.form.geo.city = hit.properties.city;
						this.form.geo.address_full = hit.properties.label;
						this.form.geo.type = hit.properties.type;
					}
					return true;
				}
			}
			this.$set(this.form, "geo", {
				address_full: "",
				score: 0,
				insee_code: "",
				postal_code: "",
				city: "",
				departement: {},
				region: {},
				lat: "",
				lon: "",
			});
		},
		get_geo_data: function () {
			//JNA : if this fiels are not empty -> WE GET IT!!!!!!
			// this.form.lat
			// this.form.lon

			const that = this;


			// Retrieve address details
			if (this.form.address && this.form.address.length > 3) {
				this.address_loading = true;
				axios.get(`${process.env.VUE_APP_API_BASE_URL}api/etalab/search/?q=` + encodeURIComponent(this.form.address))
					.then(function (response) {
						that.set_geo_data(response);
						if (!that.form.insee_code) that.form.insee_code = response.data.content.features[0].properties.citycode;
						that.reload_map(that.form.geo.lat, that.form.geo.lon);

						// Retrieve departement and region infos
						if (that.form.geo.insee_code && that.form.geo.insee_code.length == 5) {
							axios.get("https://geo.api.gouv.fr/communes/" + that.form.geo.insee_code + "?fields=departement,region,codesPostaux")
							// axios.get(`${process.env.VUE_APP_API_BASE_URL}Etalab/Api/Communes/` + that.form.geo.insee_code + "?fields=departement,region,codesPostaux")
								.then(function (response) {
									if (response.data.departement) that.form.geo.departement = response.data.departement;
									if (response.data.region) that.form.geo.region = response.data.region;
								})
								.catch(function () {
									that.set_geo_data({});
								})
								.finally(function () {
									that.address_loading = false;
								});
						} else {
							that.address_loading = true;
						}
					})
					.catch(function () {
						that.set_geo_data({});
						that.address_loading = true;
					});

			}

		},
		check_evalis_code: async function () {
			this.check_evalis_pending = true;
			const evalis_code_to_check = this.form.evalis_code === null ? "" : this.form.evalis_code;
			this.evalis_code_valid = await this.$store.dispatch("check_evalis_code", evalis_code_to_check);
			this.check_evalis_pending = false;
		},
		filterFn (val, update) {
			if (val === "") {
				update(() => {
					this.options = this.kyaneosOptions;
				});
				return;
			}

			update(() => {
				const needle = val.toLowerCase();
				this.options = this.kyaneosOptions.filter(v => v.toLowerCase().indexOf(needle) > -1);
			});
		}
	},
	mounted: function () {
		if (this.active_study && this.active_study.etudeData && this.active_study.etudeData.code_evalis_status == "pending"){
			this.$store.dispatch("check_evalis_code",this.active_study.evalisReference);
		}

		if (!this.active_project) {
			//console.error('active_project must be set before accessing this component');
			console.info("no active project ");
		}
		if (this.new_study_for_active_project) {
			this.init_geo_contributors();
		}
		if (this.mode == "edition" ) {
			this.init_projet_and_study_data();
		} else {
			this.addCurrentUserToContributors();
			//set default value to lists (segement & type)
			this.form.segment = this.study.lists.segments.filter( s => s.code == "LLI")[0];
			this.form.type = this.available_etude_types[0];

		}
		this.$nextTick(function () {
			this.init_map();
		});

		if ((!this.active_study || !this.active_study.segment) && (this.available_segments != null && this.available_segments.length > 0)){
			this.form.segment = this.available_segments[0];
		}
		this.init_form = _.cloneDeep(this.form);
	},
	components: { InputAutocomplete, RowUser }
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'
@import '../../../assets/css/grid'
@import '../../../assets/css/ui'


.form-study
	.checkbox-maquette
		margin 0 10px

	display block

	&.cols-1
		> .row
			display block
			margin 0
			> .col
				display block
				float none
				padding 0
				width 100% !important

	.map
		height 250px
		background-color #ddd
		border-radius radius
		line-height @height
		text-align center
		font-weight 500
		color #999

	.address-search
		position absolute
		right 16px
		top 16px
		left 16px
		z-index 111111
		input
			background-color alpha(#fff, 50%)
			background-color #fff
			box-shadow 0 0 4px alpha(#000, 35%)
			border-radius radius
		.disabled
			background-color lightgrey
			font-size 12px
			cursor not-allowed
		button
			position absolute
			right 0
			top 0
			height 40px
			width 40px
			border none
			background transparent
			text-align center
			cursor pointer
			opacity 0.5
			&:hover
				opacity 1
			.icon
				display block
				margin 0 auto

	.address-full
		margin 8px 0 0 0
		padding 16px
		border-radius radius
		background-color #f5f5f5
		border 2px solid #ddd
		color #666
		&:before
			content ''
			position absolute
			left 50%
			margin-left -8px
			top -8px
			width 0
			height 0
			border-style solid
			border-width 0 8px 8px 8px
			border-color transparent transparent #ddd transparent

		.address-loading
			position absolute
			top 50%
			right 16px
			margin-top -12px
			animation 1s rotate infinite linear

	.users
		margin 8px 0 0 0
		min-height 64px

		.no-user
			display flex
			align-items center
			justify-content center
			height 64px
			box-shadow inset 0 0 0 2px #eee
			text-transform uppercase
			color #ccc
			font-weight 500
			font-size 12px

		.user
			display block
			height 64px
			padding 8px
			margin 0 0 8px 0
			border-radius radius
			box-shadow inset 0 0 0 2px #eee
			line-height 24px
			white-space nowrap
			&:hover
				.user-remove
					opacity 1
			.user-initials
				float left
				width 48px
				height 48px
				display flex
				align-items center
				justify-content center
				margin 0 8px 0 0
				border-radius 100%
				background-color #eee
				font-weight 500
				color dark
				text-transform uppercase
			.user-name
				display block
				margin-left 56px
				font-weight 500
				transform translateY(2px)
			.user-description
				display block
				margin-left 56px
				transform translateY(-2px)
				color lighten(dark, 50%)
				font-size 12px
				span
					display inline-block
					margin 0 16px 0 0
					> .icon
						float left
						margin 4px 4px 0 0
				a
					text-decoration underline
					&:hover
						text-decoration none
			.user-remove
				opacity 0
				position absolute
				right -4px
				top -4px
				width 24px
				height 24px
				display flex
				align-items center
				justify-content center
				background-color red
				border-radius 100%
				box-shadow 0 0 0 4px #fff
				cursor pointer
				color #fff
				text-align center
				&:hover
					background-color darken(red, 10%)
				&:active
					background-color darken(red, 20%)
					transform translateY(1px)
				.icon
					display block

	.mandatory
		border-left-style solid
		border-left-color red

	.disabled_address
		background-color grey

	button
		width 100px

		.loading
			position absolute
			left 40%
			top 20%
			// margin-left -12px
			// margin-top -12px
			animation 1s rotate infinite linear

.field
	.icon
		margin-bottom 16px
		position absolute
		bottom -8px
		right 0
	.failed
		color red
	.pending
		animation rotate 1.5s infinite linear
	.success
		color green

</style>